<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
    mounted () {   
      console.log()
      let windowWidth= document.documentElement.clientWidth;
      let windowHeight= document.documentElement.clientHeight;
      // console.log(windowWidth,windowHeight)
       let width = document.documentElement.clientWidth || document.body.clientWidth;
      //利用当前的宽度除以设计图上的宽度 #不一定是750但是我经历的设计图大部分都是 
      let r = width / window.innerWidth;
      //获取html根元素
      let a = document.getElementsByTagName('html')[0];
      //给html根元素设置字体大小，如果进来的时候宽度不一样，根元素字体大小也会不一样
      a.setAttribute('style', 'font-size:' +  r*10  + 'px');
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if(flag) {
        window.location.href = 'http://web.softykt.cn'
      }else {
      }
    },
}
</script>
<style>
a{
  text-decoration:none !important;
}
*{
  padding: 0;
  margin: 0;
}
p{
  margin: 0 !important;
  padding: 0 !important;
}
.w120{
  width: 120rem;
  margin: 0 auto;
  position: relative;
}

</style>
